interface IconFireProps {
  className?: string
}

export function IconFire({ className }: IconFireProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
    >
      <path
        d="M5.95759 0.320175C6.11218 0.25871 6.28661 0.272972 6.42916 0.358732C9.45999 2.1821 12.2597 5.29578 13.1768 8.29726C13.6391 9.81046 13.6375 11.3515 12.867 12.6733C12.0971 13.9942 10.6219 14.9885 8.36555 15.5424C8.13939 15.5979 7.90338 15.5001 7.78274 15.3009C7.66211 15.1017 7.68479 14.8473 7.83877 14.6726C8.76164 13.6254 9.57709 12.4016 9.696 11.1127C9.78652 10.1315 9.47884 9.01971 8.29754 7.83689C8.30615 9.09565 7.82135 10.1439 7.33294 10.7434C7.20264 10.9033 6.99176 10.9736 6.79155 10.924C6.59134 10.8743 6.43778 10.7136 6.39732 10.5113C6.20209 9.53511 5.64745 9.10512 5.05677 8.80235C5.01673 9.63415 4.65393 10.2328 4.38989 10.6685L4.38987 10.6686C4.3153 10.7916 4.24861 10.9017 4.19929 11.0003C3.41368 12.5715 4.36488 13.7119 5.023 14.5009L5.02308 14.501C5.07713 14.5658 5.12921 14.6282 5.17818 14.6883C5.33006 14.8747 5.33829 15.1397 5.19828 15.3352C5.05827 15.5306 4.8047 15.6081 4.57934 15.5243C2.5446 14.7676 1.10549 13.3502 0.572627 11.6207C0.0364836 9.88051 0.447512 7.92008 1.92529 6.15687C2.39935 5.59124 2.81356 5.12206 3.17828 4.70894C4.46126 3.25569 5.13183 2.49612 5.64124 0.672004C5.68599 0.511775 5.803 0.381639 5.95759 0.320175Z"
        fill="white"
      />
    </svg>
  )
}
